<template>
  <v-container fluid>
    <v-layout column> 
      <v-flex>
        <v-container fluid grid-list-md class="grey lighten-4">
          <v-layout row wrap>
            <v-flex v-if="resultado.id" lg12 xs12 sm12 md12 xl12>
              <h1 class="headline">{{resultado.nomePaciente}}</h1>
              <h2 v-if="resultado.cpfPaciente" class="subheading">
                CPF: {{resultado.cpfPaciente}}
              </h2>
              <h2 v-if="resultado.dataNascimento" class="subheading">
                Data Nascimento: {{resultado.dataNascimento}}
              </h2>
            </v-flex>            
            <v-flex lg4 xs12 md6 v-if="resultado.id">
              <v-card>
                <v-card-media ref="resultado.id" :src="buscarImage(resultado)" height="200px">
                </v-card-media>
                <v-card-title primary-title>
                  <div>
                    <h3 class="headline mb-0">{{resultado.tipoExame}} - {{resultado.modalidade}}</h3>
                    <div> 
                      <span v-if="resultado.medico">Médico: <strong>{{resultado.medico.nome}} </strong> <br> </span>
                      <span v-if="resultado.dataAssinatura">Data Assinatura: <strong>{{moment(resultado.dataAssinatura).format('DD/MM/YYYY hh:mm') }} </strong></span>
                    </div>
                  </div>
                </v-card-title>
                <v-card-actions class="white">
                    <v-spacer></v-spacer>

                    <v-btn class="ml-1 mr-1 " v-if="resultado.medico" dark ripple color="primary" outline round @click.native="openPdf(resultado)">
                      <v-icon class="mr-2">picture_as_pdf</v-icon> Visualizar Laudo
                    </v-btn>

                    <v-btn class="ml-1 mr-1" v-if="resultado.possuiImagem" dark ripple color="primary" outline round @click.native="openViewer(resultado)" >
                      <v-icon class="mr-2">collections</v-icon> Visualizar Imagens
                    </v-btn>

                </v-card-actions>
              </v-card>   
            </v-flex>         
          </v-layout>
      </v-container>
      </v-flex>

          <PdfDialog :resultado="resultado" :link="linkPdf" :display.sync="dialogPdf"> </PdfDialog>
      <ViewerDialog :resultado="resultado" :link="linkViewer" :display.sync="dialogViewer"> </ViewerDialog>

    </v-layout>
    

  </v-container>
</template>

<script>

import PdfDialog from '@/components/PdfDialog'
import ViewerDialog from '@/components/ViewerDialog'

import axios from 'axios'
import moment from 'moment'
moment.locale('pt-BR')

export default {
  name: 'resultadoShareCard',
  data () {
    return {
      items: [],
      errors: [],
      total: null,
      cabecalho: {},
      resultado: {},
      titulo: 'Resultados',
      dialogPdf: false,
      dialogViewer: false,
      linkViewer: null,
      linkPdf: null
    }
  },
  components: {
    PdfDialog,
    ViewerDialog
  },
  computed: {
  },
  methods: {
    moment (data) {
      return moment(data)
    },
    limparSelecao () {
      console.log(this.pagination)
    },
    openPdf (res) {
      // var index = Object.keys(this.selected)[0]
      // const medico = this.selected[index]
      this.dialogPdf = true
      var link = null
      this.resultado = res
      if (res) {
        let idConnect = res.idConnect ? res.idConnect : 'laudos'
        if (res.dataAssinatura) {
          link = `https://docs.google.com/viewer?embedded=true&url=https://storage.googleapis.com/${res.intervaloStorage}/${idConnect}/${res.id}_signed.pdf`
        } else {
          link = `https://docs.google.com/viewer?embedded=true&url=https://storage.googleapis.com/${res.intervaloStorage}/${idConnect}/${res.id}_add.pdf`
        }
        this.linkPdf = link
      }
      // this.$router.push({name: 'MedicoEdit', params: { id: medico.id }})
    },
    detectmob () {
      if (navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)) {
        return true
      } else {
        return false
      }
    },
    buscarImage (res) {
      var link = `https://storage.googleapis.com/${res.intervaloStorage}/${res.idConnect}/capa.jpg`
      return link
    },
    openViewer (res) {
      this.buscarImage(res)
      console.log(res)
      if (res) {
        if (this.detectmob()) {
          link = `https://mviewer.mezzow.com/mindex.html?eid=${res.idConnect}&st=${res.intervaloStorage}&em=${res.empresa.email}`
          window.open(link, res.idConnect)
        } else {
          this.dialogViewer = true
          var link = null
          this.resultado = res
          link = `https://mviewer.mezzow.com/index.html?eid=${res.idConnect}&st=${res.intervaloStorage}&em=${res.empresa.email}`
          this.linkViewer = link
        }
      }
      // this.$router.push({name: 'MedicoEdit', params: { id: medico.id }})
    },
    atualizarLista () {
      var params = `id=${this.$route.params.share}`
      axios.get(`/shared?${params}`)
        .then(response => {
          this.resultado = response.data.resultado
          this.$store.commit('changeCabecalho', {cabecalho: response.data.cabecalho})
        })
        .catch(e => {
          if (e.response.status === 403) {
            /* window.localStorage.removeItem('token')
            axios.defaults.headers.common['X-Auth-Token'] = null
            this.menuApp = []
            this.$router.push({path: '/'})
            */
            // http://192.168.0.116:8081/#/resultado-compartilhado/5a8ed3807e5777ac4b332995
          } else {
            this.$router.push({name: 'NotFound'})
          }
        })
    }
  },

  // Fetches medicos when the component is created.
  created () {
    this.atualizarLista()
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// ResultadoShareCard.vue?758a7544